<app-layer-config-collapsible-category
  description="Standard Vehicle"
  storageKey="rc-standard-vehicle"
  [collapsedDefault]="false"
>
  <app-layer-control-item
    description="Heavy Rain"
    [isLayerVisibile]="isHeavyRainLayerVisible"
    [layerId]="layerIds.Provider4HeavyRain.name"
    icon="windshield-wiper"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Slippery Road"
    [isLayerVisibile]="isSlipperyRoadVisible"
    [layerId]="layerIds.Provider4Slippery.name"
    icon="car-waves"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
</app-layer-config-collapsible-category>
